import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TgGridModule, TgSvgModule } from '@trademe/tangram';
import { MotorsIllustrationBoatModule } from '../../components/motors-illustration-boat/motors-illustration-boat.module';
import { MotorsVehicleDetailsHeaderSectionComponent } from './motors-vehicle-details-header-section.component';

@NgModule({
    imports: [
        CommonModule,
        TgGridModule,
        TgSvgModule,
        MotorsIllustrationBoatModule
    ],
    declarations: [MotorsVehicleDetailsHeaderSectionComponent],
    exports: [MotorsVehicleDetailsHeaderSectionComponent]
})
export class MotorsVehicleDetailsHeaderSectionModule {}
